export const FALLBACK_TIMEZONE = 'UTC';

// Intl.DateTimeFormat accepts offset identifiers like '+00:00' as valid time zones
// per ECMA-402, so constructibility alone doesn't prove a zone name. IANA names
// always start with a letter, which offsets never do.
const IANA_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9_+\-/]*$/;

/**
 * Checks whether a string is a real IANA timezone identifier.
 * Guards against environments where the browser's Intl API falls back to a raw
 * UTC offset (e.g. '+00:00') instead of a zone name.
 */
export const isValidIanaTimezone = (timezone: string): boolean => {
  if (!IANA_NAME_PATTERN.test(timezone)) {
    return false;
  }

  try {
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: timezone });
    return Boolean(formatter);
  } catch {
    return false;
  }
};
